/* ls-stade-motion-tribunes — "Trouver sa place" accordion on the native aiconeo section (p70).
 *
 * Native content (scripts/out/stade-nocss/p70/scenes/tribunes.mjs), recognised by type + order:
 *   one container whose element children are ≥2 images-with-children (the stand panels: photo,
 *   linkUrl, gold chip button), and after it the section's CTA button(s).
 *
 * Motion = the original sections/ls-stade-tribunes.liquid behaviour (assets/ls-stade-tribunes.css):
 *   - one panel always open (2:1 flex ratio on ≥750px, 320px vs 160px in the phone stack); hover /
 *     focus hands the width to another panel; only the open panel shows its chip on desktop;
 *   - the CTA sits over the photos, centred near the bottom, on ≥750px (below them on phones);
 *   - touch/pen: the first tap on a closed panel opens it, the second follows the link.
 * Layout is CSS (ls-stade-motion-tribunes.css) under .ls-trib--on; this script only recognises the
 * structure, stamps runtime classes and handles taps. Any panel count; anything unrecognised →
 * the native page stays untouched.
 */
(function () {
  'use strict';
  if (!window.LsStadeMotion) return;

  function elementChildren(node) {
    return Array.prototype.filter.call(node.children, function (c) {
      return c.tagName !== 'STYLE' && c.tagName !== 'SCRIPT';
    });
  }

  LsStadeMotion.scene('tribunes', function (section, ctx) {
    if (ctx.reduced) return null;

    // Top-level overlay images (not an image nested inside another image's layer).
    var images = ctx.items('.content-type-neo-image--overlay').filter(function (img) {
      return !img.parentElement.closest('.content-type-neo-image');
    });
    if (images.length < 2) return null;
    var row = images[0].parentElement;
    var kids = elementChildren(row);
    if (kids.length !== images.length) return null;
    for (var i = 0; i < kids.length; i++) if (kids[i] !== images[i]) return null;

    // CTA: the section's button(s) after the row, outside the panels. Its block = the ancestor
    // that is a sibling-level box of the row's block (both below their common ancestor).
    var ctaButtons = ctx.items('button').filter(function (b) {
      return !b.closest('.content-type-neo-image') &&
        (row.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING);
    });
    var ctaBlock = null;
    var ctaInner = null;
    if (ctaButtons.length) {
      ctaBlock = ctaButtons[0];
      while (ctaBlock.parentElement && ctaBlock.parentElement !== section && !ctaBlock.parentElement.contains(row)) {
        ctaBlock = ctaBlock.parentElement;
      }
      // Every CTA button must live in that one block, and the block must not hold the row.
      var ok = ctaBlock.parentElement && ctaBlock.parentElement.contains(row) && !ctaBlock.contains(row) &&
        ctaButtons.every(function (b) { return ctaBlock.contains(b); });
      if (ok) {
        ctaInner = elementChildren(ctaBlock).filter(function (c) { return c.contains(ctaButtons[0]); })[0] || null;
        if (!ctaInner) ok = false;
      }
      if (!ok) { ctaBlock = null; ctaInner = null; }
    }

    row.classList.add('ls-trib-row');
    images.forEach(function (panel, idx) {
      panel.classList.add('ls-trib-panel');
      panel.classList.toggle('ls-trib-panel--open', idx === 0);
      // The chip's builder font size is the ceiling of its panel-relative scale (CSS).
      var chipLinks = panel.querySelectorAll('.neo-image__overlay .neo-button');
      Array.prototype.forEach.call(chipLinks, function (a) {
        if (a.style.fontSize) a.style.setProperty('--ls-trib-chip-fs', a.style.fontSize);
      });
    });
    if (ctaBlock) {
      ctaBlock.classList.add('ls-trib-cta');
      ctaInner.classList.add('ls-trib-cta__inner');
      // The row's own block (sibling of the CTA block): its bottom edge is the anchor of the CTA.
      var rowBlock = row;
      while (rowBlock.parentElement && rowBlock.parentElement !== ctaBlock.parentElement) rowBlock = rowBlock.parentElement;
      if (rowBlock.parentElement === ctaBlock.parentElement) rowBlock.classList.add('ls-trib-rowblock');
    }

    // Touch / pen: first tap opens, second follows. Mouse (hover already opened it) and keyboard
    // (click.detail === 0) go straight through. Pointer type read at pointer time.
    var pointerType = 'mouse';
    row.addEventListener('pointerdown', function (event) {
      pointerType = event.pointerType || 'mouse';
    }, true);
    row.addEventListener('click', function (event) {
      if (pointerType === 'mouse' || event.detail === 0) return;
      var panel = event.target.closest && event.target.closest('.ls-trib-panel');
      if (!panel || panel.parentElement !== row) return;
      if (panel.classList.contains('ls-trib-panel--open')) return;
      event.preventDefault();
      images.forEach(function (other) {
        other.classList.toggle('ls-trib-panel--open', other === panel);
      });
    }, true);

    section.classList.add('ls-trib--on');
    return null;
  });
})();
